const validateName = (name: string): boolean => name.length < 17 && /^[A-Za-z0-9 &_+,:;=?@#|'"<>.^*()%!/-]+$/.test(name)

export default validateName
